var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMedical(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#1B75BC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2006 11.9961H20.0006M9.60059 17.5961H11.5166C11.7518 17.5961 11.9838 17.6489 12.1942 17.7513L13.8278 18.5417C14.0382 18.6433 14.2702 18.6961 14.5062 18.6961H15.3398C16.1462 18.6961 16.8006 19.3289 16.8006 20.1097C16.8006 20.1417 16.779 20.1689 16.7478 20.1777L14.715 20.7401C14.3502 20.8409 13.9613 20.8056 13.6206 20.6409L11.8742 19.7961M15.2006 10.3961V13.5961C15.2006 13.9113 15.2627 14.2234 15.3833 14.5145C15.5039 14.8057 15.6807 15.0703 15.9035 15.2932C16.1264 15.516 16.391 15.6928 16.6821 15.8134C16.9733 15.934 17.2854 15.9961 17.6006 15.9961C17.9158 15.9961 18.2278 15.934 18.519 15.8134C18.8102 15.6928 19.0748 15.516 19.2976 15.2932C19.5205 15.0703 19.6973 14.8057 19.8179 14.5145C19.9385 14.2234 20.0006 13.9113 20.0006 13.5961V10.3961C20.0006 10.0809 19.9385 9.76884 19.8179 9.47765C19.6973 9.18647 19.5205 8.9219 19.2976 8.69904C19.0748 8.47618 18.8102 8.29939 18.519 8.17878C18.2278 8.05817 17.9158 7.99609 17.6006 7.99609C17.2854 7.99609 16.9733 8.05817 16.6821 8.17878C16.391 8.29939 16.1264 8.47618 15.9035 8.69904C15.6807 8.9219 15.5039 9.18647 15.3833 9.47765C15.2627 9.76884 15.2006 10.0809 15.2006 10.3961Z",
    stroke: "white",
    strokeWidth: 1.04,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8006 19.5932L20.475 18.4644C20.7949 18.3662 21.1376 18.3716 21.4542 18.4798C21.7709 18.588 22.0452 18.7934 22.2382 19.0668C22.5334 19.4748 22.4134 20.0604 21.983 20.3084L15.971 23.778C15.783 23.8868 15.5748 23.9561 15.3592 23.9818C15.1435 24.0076 14.9249 23.9891 14.7166 23.9276L9.60059 22.4092",
    stroke: "white",
    strokeWidth: 1.04,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedical);
export default __webpack_public_path__ + "static/media/medical.391aa42718853e1e1090dbbc1805e766.svg";
export { ForwardRef as ReactComponent };